/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesProductCollection containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum layout {
    carousel = 'carousel',
    grid = 'grid'
}

export interface IDobbiesProductCollectionConfig extends Msdyn365.IModuleConfig {
    productCollection: Msdyn365.IProductList;
    heading?: IHeadingData;
    allowedRelationType?: string;
    layout?: layout;
    allowBackNavigation?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    clientRender?: boolean;
    enableAffiliationBasedPricing?: boolean;
    shouldDisplaySeeAllButton?: boolean;
    className?: string;
    redirectToCart?: boolean;
    isProductBundles?: boolean;
    isBundlesModal?: boolean;
    isNotificationModal?: boolean;
    discountAppliedInCartMessage?: string;
    maxQuantityReachedInBundlesmsg?: string;
}

export interface IDobbiesProductCollectionResources {
    priceFree: string;
    priceRangeSeparator: string;
    ratingAriaLabel: string;
    flipperNext: string;
    flipperPrevious: string;
    originalPriceText: string;
    currentPriceText: string;
    ratingCountAriaLabel: string;
    ratingCountAriaLabelSingleUser: string;
    seeAllButtonText: string;
    addToCartButtonText: string;
    addedToCartSuccessMessage: string;
    addedToCartFailureMessage: string;
    maxQuantityLimitText: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IDobbiesProductCollectionProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesProductCollectionResources;
    config: IDobbiesProductCollectionConfig;
    slots: {
        quickview: React.ReactNode[];
        productComparisonButton: React.ReactNode[];
        storeSelectors: React.ReactNode[];
    };
}
